
import './offer.css';
import { useNavigate } from 'react-router-dom';
import MenuPlans from './MenuPlans';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const PlanLunar = () => {
  const navigate = useNavigate();
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      fontFamily: 'Inter, Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    }}>
      <MenuPlans />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 18 }}>
          <div style={{
            display: 'inline-block',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            padding: '8px 20px',
            borderRadius: 50,
            fontSize: 14,
            fontWeight: 600,
            marginBottom: 18,
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.18)'
          }}>
            Perfect pentru flexibilitate
          </div>
          <h1 style={{ fontSize: '2.3rem', fontWeight: 800, marginBottom: 8, color: '#1a202c', textAlign: 'center' }}>Plan Premium Lunar</h1>
          <p style={{ color: '#4a5568', fontSize: '1.15rem', marginBottom: 0, textAlign: 'center', maxWidth: 420 }}>
            Acces complet la toate cursurile și funcționalitățile platformei.
          </p>
        </div>
        <div className="offerdiscount-card" style={{ margin: 0, boxShadow: '0 8px 32px rgba(102,126,234,0.10), 0 2px 8px rgba(22,199,158,0.10)' }}>
          <div className="offerdiscount-price" style={{ justifyContent: 'center' }}>
            <span className="offerdiscount-price-main">70 LEI</span>
            <span style={{ fontSize: '1.1rem', color: '#6b7280', fontWeight: 500 }}>/lună</span>
          </div>
          <ul className="offerdiscount-benefits">
            <li><FontAwesomeIcon icon={faCheck} className="item-bifa" /> Acces nelimitat la toate cursurile</li>
            <li><FontAwesomeIcon icon={faCheck} className="item-bifa" /> 300+ lectii interactive</li>
            <li><FontAwesomeIcon icon={faCheck} className="item-bifa" /> Exercitii si aplicatii practice</li>
            <li><FontAwesomeIcon icon={faCheck} className="item-bifa" /> Jocuri educationale</li>
            <li><FontAwesomeIcon icon={faCheck} className="item-bifa" /> Anulare oricand</li>
          </ul>
          <button
            className="offerdiscount-btn"
            style={{ marginBottom: 10 }}
            onClick={() => navigate('/facturare?plan=monthly')}
          >
            Continua catre plata
          </button>
          <div style={{ color: '#16c79e', fontWeight: 500, fontSize: 14, marginTop: 6, textAlign: 'center' }}>
            <FontAwesomeIcon icon={faCheck} style={{ marginRight: 6 }} /> Garanție de rambursare 14 zile
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanLunar;
